import { z } from 'zod'

export const MEMBERSHIP_SCIM_TENANT_WRITE_CONTRACT_VERSION = '1.0.0' as const

export const membershipScimTenantWriteResponseSchema = z.object({
  secretReplayAvailable: z.boolean().optional(),
}).passthrough()

export type MembershipScimTenantWriteResponse = z.infer<typeof membershipScimTenantWriteResponseSchema>
